<div class="page_heading">
  <div class="container">
    <h2>Privacy Policy</h2>
  </div>
</div>

<section class="rs-legal" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-spark" style="--sx: 8%; --sy: 30%; --sd: 0.6s"></span>
  </div>

<div class="container rs-legal__doc" rsReveal="up">
    <h1 class="my-4">Privacy Policy for Housie Mania Game</h1>



<h3>1. Introduction</h3>
<p>Welcome to Housie Mania! This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you use our game. By accessing and using Housie Mania, you consent to the practices described in this policy.</p>

<h3>2. Information We Collect</h3>

<p>2.1. Personal Information: We may collect personal information such as your name, email address, and in-game username when you register or use certain features of the game.</p>

<!-- <p>2.2. Non-Personal Information: We may also collect non-personal information such as device information, IP address, and gameplay data to improve the game's performance and user experience.</p> -->

<p>2.2 Non-Personal Information</p>
<p>
    When you use Housie Mania, we and our partners (such as AdMob by Google) may automatically collect certain non-personal information, including:</p>
<ul>

<li>

Device information (model, OS version, device identifiers)
</li>
<li>


IP address (used to estimate general location)
</li>
<li>
Advertising ID (used for delivering personalized or non-personalized ads)
</li>
<li>


App usage data (such as gameplay activity, ad views, and interactions with ads)
</li>
<li>
Crash logs and performance data (to improve stability and performance)
</li>
</ul>

<h3>3. How We Use Your Information</h3>

<p>3.1. Personal Information: We may use your personal information to:

    Create and manage your user account.
    Communicate with you regarding game updates, notifications, and support.
    Respond to your inquiries and feedback.</p>

<!-- <p>3.2. Non-Personal Information: We may use non-personal information for analytics, game improvement, and to personalize your gaming experience.</p> -->

<p>3.2 Non-Personal Information</p>
<p>
We and our partners may use non-personal information to:</p>
<ul>

<li>
Display Banner Ads and Interstitial Ads
</li>
<li>
Personalize and measure ad performance
</li>
<li>
Improve gameplay experience and app performance
</li>
<li>
Analyze usage trends and prevent fraud or misuse
</li>
<li>
Crash logs and performance data (to improve stability and performance)
</li>


</ul>

<h3>4. Sharing Your Information</h3>

<p>We use Google AdMob to display Banner and Interstitial Ads in Housie Mania. AdMob may collect and process data as described above to deliver relevant ads, including:</p>
<ul>
    <li>

    Device information, IP address, and advertising ID
    </li>
    <li>

 
Ad interactions (such as impressions and clicks)
   </li>
   <li>
App performance and crash data
   </li>
<p>For more details on how Google uses this data, please review the Google Privacy Policy: https://policies.google.com/privacy</p>

</ul>

<h3>5. Security</h3>

<p>We take appropriate measures to protect your personal information, but please be aware that no method of data transmission or storage is 100% secure. We cannot guarantee the security of your information.</p>

<h3>6. Cookies and Analytics</h3>

<p>We may use cookies and analytics tools to collect non-personal information about your usage of the game. These tools help us improve the game and provide a better experience.</p>

<h3>7. Children's Privacy</h3>

<p>Housie Mania is not intended for children under the age of 13. We do not knowingly collect or store personal information from children under 13.</p>

<h3>8. Changes to Privacy Policy</h3>

<p>We may update this Privacy Policy to reflect changes in our practices. Any updates will be posted on this page, and the "Last Updated" date will be revised accordingly.</p>

<h3>9. Contact Information</h3>

<p>If you have questions or concerns about this Privacy Policy, please contact us at app&#64;resiliencesoft.com</p>

<h3>10. Consent</h3>

<p>By using Housie Mania, you consent to this Privacy Policy.</p>
</div>
</section>